import { Button, Col, message, ModalProps, Radio, Row } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { Link } from 'react-router-dom';
import { paymentPackageAssigned } from 'src/api/package_assigned';
import {
  getDetailPackage,
  registerAndCancelPackage,
} from 'src/api/register_and_cancel_and_load_package';
import BoxWithLabel from 'src/components/BoxWithLabel/BoxWithLabel';
import Loading from 'src/components/CLoading';
import ModalConfirm from 'src/components/modals/ModalComfirm';
import { usePermission } from 'src/hooks/usePermission';
import { useAppDispatch, useAppSelector } from 'src/redux/hook';
import { setGlobalState } from 'src/redux/slice/globalSlice';
import { resetModalState, setModalState } from 'src/redux/slice/modal.store';
import { TransactionHistoryType } from 'src/shared/enum/localpay';
import { OrderStatusEnum } from 'src/shared/enum/package_assigned';
import { TransactionHistory } from 'src/shared/interface/localpay.interface';
import { OrderRequest } from 'src/shared/interface/package_assigned';
import { formatDateTime, formatMoney, useRenderLinkDirectTo } from 'src/utils';
import { useOpenMenuTab } from 'src/utils/openMenuTab';

interface ModalTopUpProps extends ModalProps {
  selectedHistory?: TransactionHistory;
}

function RegisterBillingLocalModal({ selectedHistory }: ModalTopUpProps) {
  const dispatch = useAppDispatch();
  const { order, refresh } = useAppSelector((state) => state.global);
  const merchantInfo: string | null = localStorage.getItem('merchantInfo');
  const { openMenuTab } = useOpenMenuTab();
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [dataDetailLine, setDataDetailLine] = useState<
    {
      mbfCode: string;
      toTalAmount: number;
      countItem: number;
      discountAmount: number;
    }[]
  >([]);

  const { hasPermission, PERMISSIONS } = usePermission();

  async function handlePayBill() {
    setIsModalLoading(true);
    setOpenModalConfirm(false);
    if (merchantInfo) {
      const data: OrderRequest = {
        accountNumber: JSON.parse(merchantInfo).payAccountId ?? '',
        orderId: order?.id ? order?.id : '',
        type: 14,
        distibutorId: merchantInfo ? JSON.parse(merchantInfo).merchantId : '',
        description: '',
        updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
      };
      try {
        // thanh toan don hang dang ky goi
        const res = await paymentPackageAssigned(data);
        if (res) {
          const data: OrderRequest = {
            orderId: order?.id ? order?.id : '',
            updatedBy: merchantInfo ? JSON.parse(merchantInfo).merchantName : '',
            // simType: form.getFieldValue('simType'),
          };

          await registerAndCancelPackage('initiate', data);

          dispatch(setGlobalState({ refresh: !refresh }));
          dispatch(setModalState({ open: false }));
          message.success('Thanh toán thành công');
        }
      } catch (error) {
        console.log(error);
      }
    }
    setIsModalLoading(false);
    dispatch(setGlobalState({ refresh: !refresh }));
  }

  const fetchDetailOrder = async (id: string) => {
    const res = await getDetailPackage('initiate', id);
    if (res) {
      dispatch(setGlobalState({ order: res }));
    }
  };

  useEffect(() => {
    if (selectedHistory && selectedHistory.paymentId) {
      fetchDetailOrder(selectedHistory.paymentId);
    }
  }, [selectedHistory]);

  useEffect(() => {
    if (order) {
      const listDataDetail: {
        mbfCode: string;
        toTalAmount: number;
        countItem: number;
        discountAmount: number;
      }[] = [];
      order?.overFlowOrderDetailResponses?.forEach((item: any) => {
        const findIndexTopup = listDataDetail.findIndex(
          (predicate) => predicate.mbfCode === item?.mbfCode,
        );
        if (findIndexTopup === -1) {
          listDataDetail.push({
            mbfCode: item.mbfCode,
            toTalAmount: item.price,
            countItem: 1,
            discountAmount: item.extraDataObject?.discountAmount,
          });
        } else {
          listDataDetail[findIndexTopup] = {
            ...listDataDetail[findIndexTopup],
            countItem: listDataDetail[findIndexTopup].countItem + 1,
            toTalAmount: listDataDetail[findIndexTopup].toTalAmount + item.price,
            discountAmount:
              listDataDetail[findIndexTopup]?.discountAmount + item.extraDataObject?.discountAmount,
          };
        }
      });

      setDataDetailLine(listDataDetail);
    }
  }, [order]);

  const handleOpenMenuTab = () => {
    if (selectedHistory) {
      openMenuTab({ selectedHistory });
    }
  };

  return (
    <Fragment>
      {isModalLoading && <Loading />}
      <div className='flex justify-end'>
        <button
          onClick={() => dispatch(resetModalState())}
          className=' text-3xl cursor-pointer border-transparent bg-transparent'
        >
          <RxCross2 />
        </button>
      </div>
      <BoxWithLabel title='Thông tin thanh toán' classNames='mb-[1.5rem]'>
        <Row gutter={[16, 16]}>
          <Col span={24} md={12}>
            Mã giao dịch: {order?.transactionId}
          </Col>
          <Col span={24} md={12}>
            Ngày:{' '}
            {order?.transactionDate && new Date(order?.transactionDate).getFullYear() > 1900
              ? formatDateTime(order.transactionDate)
              : formatDateTime(new Date())}
          </Col>
          <Col span={24} md={12}>
            Diễn giải: Trừ tiền nạp tiền Đăng ký gói
          </Col>
          <Col span={24} md={12}>
            Tình trạng: {order?.transactionStatusString}
          </Col>
          <Col span={24} md={12}>
            Người thanh toán: {merchantInfo ? JSON.parse(merchantInfo).merchantName : '-'}
          </Col>
          <Col span={24} md={12}>
            Đơn hàng tham chiếu:{' '}
            <Link
              onClick={(e) => {
                e.preventDefault();
                dispatch(resetModalState());
                handleOpenMenuTab();
              }}
              className='hover:underline underline'
              to={useRenderLinkDirectTo({
                id: selectedHistory?.paymentId || selectedHistory?.id,
                type: selectedHistory?.type,
              })}
            >
              {order?.id}
            </Link>
          </Col>
        </Row>
        <p className='font-bold mb-[0.5rem]'>Chi tiết hóa đơn:</p>
        <div className='normal-table max-h-96 overflow-y-auto'>
          <table width='100%' className='normal-table'>
            <thead>
              <tr>
                <th>STT</th>
                <th>Số lượng</th>
                <th>Mã hàng</th>
                <th>Tổng tiền</th>
                <th>Tiền chiết khấu</th>
                <th>Thành tiền</th>
              </tr>
            </thead>
            <tbody>
              {dataDetailLine.map((predicate, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{predicate.countItem ?? 1}</td>
                    <td>{predicate?.mbfCode ? predicate?.mbfCode : ''}</td>
                    <td>
                      {predicate?.toTalAmount ? formatMoney(predicate?.toTalAmount, 'đ') : '-'}
                    </td>
                    <td>
                      {predicate?.toTalAmount ? formatMoney(predicate?.discountAmount, 'đ') : '0đ'}
                    </td>
                    <td>
                      {predicate?.toTalAmount ? formatMoney(predicate?.toTalAmount, 'đ') : '-'}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td></td>
                <td></td>
                <td className='font-semibold'>Tổng cộng</td>
                <td>{order?.toTalAmount ? formatMoney(order?.toTalAmount, 'đ') : '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </BoxWithLabel>
      <BoxWithLabel title='Hình thức thanh toán' classNames='mb-[1.5rem]'>
        <Radio checked className='mb-[0.5rem]'>
          Localpay
        </Radio>
        <Row gutter={[16, 16]}>
          <Col span={24} md={12}>
            LocalPay ID: {merchantInfo ? JSON.parse(merchantInfo).payAccountId : '-'}
          </Col>
          <Col span={24} md={12}>
            Tên chủ tài khoản: {merchantInfo ? JSON.parse(merchantInfo).merchantName : '-'}
          </Col>
          {/* <Col span='4'>Số dư:</Col>
          <Col span='4'>{balance ? formatMoney(balance, 'đ') : '-'}</Col> */}
        </Row>
      </BoxWithLabel>
      {[
        TransactionHistoryType.Topup,
        TransactionHistoryType.Recharge,
        TransactionHistoryType.RechargeAsimPortal,
      ].includes(order?.type as TransactionHistoryType) ? (
        <Row className='my-4'>
          <Row gutter={[16, 16]} className='w-full'>
            <Col span={24} md={12}>
              Người tạo: {order?.createdBy}
            </Col>
          </Row>
          <Row gutter={[16, 16]} className='w-full'>
            <Col span={24} md={12}>
              Ngày tạo: {order?.createdAt ? formatDateTime(order?.createdAt) : '-'}
            </Col>
          </Row>
        </Row>
      ) : (
        <Row className='my-4 border-solid border px-4'>
          <Col span={24}>
            <Row gutter={[16, 16]} className='w-full'>
              <Col span={24} md={12}>
                Người tạo: {order?.createdBy}
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[16, 16]} className='w-full'>
              <Col span={24} md={12}>
                Ngày tạo: {order?.createdAt ? formatDateTime(order?.createdAt) : '-'}
              </Col>
            </Row>
          </Col>
        </Row>
      )}
      {(order?.statusString === OrderStatusEnum.PAYMENT_FAIL ||
        order?.statusString === OrderStatusEnum.New) &&
        hasPermission(PERMISSIONS.TOPUP.PAYMENT) && (
          <div className='row-button justify-end'>
            <Button
              onClick={() => setOpenModalConfirm(true)}
              disabled={
                order?.statusString !== OrderStatusEnum.PAYMENT_FAIL &&
                order?.statusString !== OrderStatusEnum.New
              }
            >
              Thanh toán
            </Button>
          </div>
        )}
      <ModalConfirm
        open={openModalConfirm}
        content={
          <div className='pb-0 p-8'>
            <div className='font-black text-3xl mb-4'>Xác nhận thanh toán?</div>
            <p>
              Bạn có chắc chắn muốn thanh toán{' '}
              {order?.toTalAmount ? formatMoney(order?.toTalAmount, 'đ') : '-'} cho đơn hàng này?
            </p>
            <div className='flex flex-col md:flex-row gap-4 h-[54px] w-full mt-12 mb-16 md:mb-0'>
              <Button onClick={handlePayBill} className='h-full w-full' disabled={isModalLoading}>
                XÁC NHẬN
              </Button>
              <Button
                className='h-full w-full'
                onClick={() => {
                  setOpenModalConfirm(false);
                }}
              >
                THOÁT
              </Button>
            </div>
          </div>
        }
      />
    </Fragment>
  );
}

export default RegisterBillingLocalModal;
